// Public routes that don't require authentication. Shared by App.tsx (to gate
// the account-scoped /me query) and components/Router.tsx (to gate the Refined
// access probe), so the two boundaries never disagree about what counts as
// public. Per ARCHITECTURE.md and docs/SECURITY.md these routes intentionally
// run outside account/organization authority.
export const PUBLIC_ROUTES = ["/user/", "/privacypolicy", "/login", "/q/"]

export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_ROUTES.some((route) => pathname.toLowerCase().startsWith(route))
}
